(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/matchen/assets/javascripts/views/coupon/reduction/reductions-list.js') >= 0) return;  svs.modules.push('/modules/matchen/assets/javascripts/views/coupon/reduction/reductions-list.js');

'use strict';

svs.matchen = svs.matchen || {};
svs.matchen.views = svs.matchen.views || {};

svs.matchen.views.ReductionsList = Marionette.CollectionView.extend({
  options: {
    xperten: false
  },

  className: 'reduction-toggles',

  childViewContainer: '.reduction-toggles',

  childView: svs.matchen.views.Reduction

});


 })(window);